import ServerGridConfig from "../../../../config/ServerGridConfig";
import { AgGridReact } from "@ag-grid-community/react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { vsmCommon } from "../../../../config/messages";
import { DateComparator, default_roles, insurance_status, insurance_type } from "../../../../utils/GlobalFunction";
import { faEye, faInfoCircle, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "antd";
const ActionRenderer = observer((props) => {
	// const { ManageZFormsStore, AUTH } = useStore();
	const { AUTH } = useStore();
	const {
		openViewModal,
		openEditModal
	} = props.agGridReact.props.frameworkComponents
	return (
		<div className="action-column">
			{AUTH.checkPrivileges("#15505#") && (
				<Button
					type="text"
					title={"View"}
					className="viewIcon mr-10"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openViewModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faEye} />
				</Button>
			)}
			{AUTH.checkPrivileges("#15503#") && (
				<Button
					type="text"
					title={"Edit"}
					className="editIcon"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openEditModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faPencilAlt} />
				</Button>)}
		</div>
	);
});

const ListComponent = observer((props) => {
	const {
		openEditModal,
		openViewModal,
	} = props;
	const { InsurancePendingStore: { setupGrid }, AUTH } = useStore();

	const insurance_status_color = {
		5: 'pinkText',
		10: 'purpleText',
		20: 'blueText',
		30: 'lightPurpleText',
		99: 'orangeText',
		105: 'blueText',
	}

	const insurance_type_color = {
		10: 'greenText',
		20: 'blueText',
		30: 'orangeText'
	}

	const gridOptions = {
		columnDefs: [
			{
				headerName: "Code",
				field: "code",
			},
			{
				headerName: "Z-Form",
				field: "booking_id",
				valueGetter: function (params) {
					if (params.data && params.data.booking_id) {
						return params.data.booking_id
					} else {
						return "N/A"
					}
				},
				filter: "agNumberColumnFilter",
			},
			{
				headerName: "Last Followup date",
				field: "last_ins_followup.date",
				filter: "agDateColumnFilter",
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
					comparator: DateComparator,
					browserDatePicker: true
				},
			},
			{
				headerName: "Next Followup",
				field: "nf_date",
				filter: "agDateColumnFilter",
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
					comparator: DateComparator,
					browserDatePicker: true
				},
			},
			{
				headerName: "Customer",
				field: "ins_customer.full_name",
			},
			{
				headerName: "Location",
				field: "location.name",
			},
			{
				headerName: "Model",
				field: "ins_vehicle.model.model",
				initialHide: true,
			},
			{
				headerName: "Variant",
				field: "ins_vehicle.variant",
			},
			{
				headerName: "Contact Number",
				field: "ins_customer.phone1",
				filter: "agNumberColumnFilter",
				hide: [default_roles.admin].includes(AUTH?.user?.role_id) ? false : true,
			},
			{
				headerName: "Remarks",
				field: "last_ins_followup.note",
				cellRendererFramework: function (params) {
					return <Tooltip title={params?.data?.last_ins_followup?.note}><FontAwesomeIcon icon={faInfoCircle} /></Tooltip>
				},
			},
			{
				headerName: "Type",
				field: "type_id",
				sortable: false,
				filter: "agSetColumnFilter",
				cellRendererFramework: function (params) {
					return <p className={insurance_type_color[params.data.type_id]}>{insurance_type[params.data.type_id]}</p>
				},
				filterParams: {
					defaultToNothingSelected: true,
					buttons: ['apply', 'reset'],
					values: (params) => {
						params.success([insurance_type[10], insurance_type[20], insurance_type[30]])
					}
				}
			},
			{
				headerName: "Status",
				field: "status",
				sortable: false,
				filter: "agSetColumnFilter",
				cellRendererFramework: function (params) {
					return <p className={insurance_status_color[params.data.status]}>{insurance_status[params.data.status]}</p>
				},
				filterParams: {
					defaultToNothingSelected: true,
					buttons: ['apply', 'reset'],
					values: (params) => {
						params.success([insurance_status[5], insurance_status[10], insurance_status[20], insurance_status[30], insurance_status[99], insurance_status[105]])
					}
				}
			},
			{
				headerName: "Actions",
				field: "actions",
				type: "actionColumn",
				filter: false,
				sortable: false,
				pinned: "right",
				minWidth: 120,
				width: 120,
			},
		],
	};
	return (
		<div className="ag-theme-alpine grid_wrapper">
			<AgGridReact
				rowHeight={ServerGridConfig.rowHeight}
				headerHeight={ServerGridConfig.headerHeight}
				modules={AllModules}
				columnDefs={gridOptions.columnDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				frameworkComponents={{
					ActionRenderer,
					openViewModal,
					openEditModal,
				}}
				overlayNoRowsTemplate={vsmCommon.noRecord}
				onGridReady={setupGrid}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
});

export default ListComponent;
